document.addEventListener("DOMContentLoaded", function () {

  const container = document.getElementById("offersContainer");
  const bar = document.getElementById("offersBar");
  const overlay = document.getElementById("offersOverlay");
  const drawer = document.getElementById("offersDrawer");

  if (!container || !bar) return;

  function openDrawer(e) {
    if (e) e.stopPropagation();
    container.classList.add("active");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer() {
    container.classList.remove("active");
    document.body.classList.remove("drawer-open");
  }

  bar.addEventListener("click", function (e) {
    if (container.classList.contains("active")) {
      closeDrawer();
    } else {
      openDrawer(e);
    }
  });

  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && container.classList.contains("active")) {
      closeDrawer();
    }
  });

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

});
